<template>
    <div>
        <ContactPoints
            v-if="section._type === 'sectionContactPoints'"
            :content="page"
        />
        <ContentColumnImageColumn
            v-if="section._type === 'sectionContentColumnImageColumn'"
            :section="section"
        />
        <ContentColumns
            v-if="section._type === 'sectionContentColumns'"
            :section="section"
        />
        <ContentMultiTabs
            v-if="section._type === 'sectionMultiTabs'"
            :section="section"
        />
        <CtaAnchorTabs
            v-if="section._type === 'sectionAnchorTabs'"
            :section="section"
        />
        <CtaHeadingBlurbButton
            v-if="section._type === 'sectionCTAHeadingBlurbButton'"
            :section="section"
        />
        <HeadingBlurbSeparator
            v-if="section._type === 'sectionHeadingBlurbSeparator'"
            :section="section"
        />
        <HtmlContent
            v-if="
                (section._type === 'column' &&
                    section.columnStyle === 'htmlContent') ||
                section._type === 'sectionHtmlContent'
            "
            :content="section"
            :thumbnail="thumbnail"
        />
        <PageUnderConstruction
            v-if="section._type === 'sectionPageUnderConstruction'"
            :content="section"
        />
        <FeaturedIndustries
            v-if="section._type === 'sectionFeaturedIndustries'"
            :items="page.industries"
            :content="section"
        />
        <FeaturedCategories
            v-if="section._type === 'sectionFeaturedCategories'"
            :page="page"
            :content="section"
        />
        <FeaturedPosts
            v-if="section._type === 'sectionFeaturedPosts'"
            :page="page"
            :content="section"
        />
        <FeaturedProfiles
            v-if="section._type === 'sectionFeaturedProfiles'"
            :page="page"
            :content="section"
        />
        <FeaturedTestimonials
            v-if="section._type === 'sectionFeaturedTestimonials'"
            :page="page"
            :content="section"
        />

        <MapLocations
            v-if="section._type === 'sectionLocationsMap'"
            :content="section"
            :locations="page && page.locations ? page.locations : null"
        />
        <SuperHero
            v-if="section._type === 'sectionSuperHero'"
            :content="section"
        />
        <SubHero v-if="section._type === 'sectionSubHero'" :content="section" />
        <PostsLayout
            v-if="
                section._type === 'sectionListBlog' ||
                section._type === 'sectionListWhitepapers'
            "
            :content="section"
            :page="page"
        />
        <EmbedEbook
            v-if="section._type === 'sectionEbook'"
            :url="section.eBook.url"
            :height="section.eBook.height"
            :maxWidth="section.eBook.maxWidth"
        />
        <v-container
            v-if="section._type === 'sectionResponsiveImage'"
            :fluid="section.fullWidth"
        >
            <EmbedSanityImage
                :selectedImage="
                    section.responsiveImage
                        ? section.responsiveImage.selectedImage
                        : section.image.selectedImage
                "
                :selectedImageEs="
                    section.responsiveImage
                        ? section.responsiveImage.selectedImageEs ||
                          section.responsiveImage.selectedImage
                        : section.image.selectedImage
                "
                classes="my-0 no-border-radius"
                :alt="section.image.alt"
            />
        </v-container>
        <!-- <EmbedCloudinary2
            v-if="section._type === 'sectionResponsiveImage'"
            :image-id="section.image.imageId"
            :image-dir="section.image.imageDir"
            :image-align="section.image.align"
            classes=" my-0 no-border-radius"
            :alt="
                section.image.alt && section.image.alt[$i18n.locale]
                    ? section.image.alt
                    : { en: 'c3controls image', es: 'c3controls image' }
            "
        /> -->
        <ShopRoom
            v-if="
                section._type === 'sectionShop' && $vuetify.breakpoint.mdAndUp
            "
        />
        <Shop
            v-if="
                section._type === 'sectionShop' && $vuetify.breakpoint.smAndDown
            "
        />
    </div>
</template>
<script>
import ContactPoints from '~/components/ContactPoints'
import ContentColumnImageColumn from '~/components/ContentColumnImageColumn'
import ContentColumns from '~/components/ContentColumns'
import ContentMultiTabs from '~/components/ContentMultiTabs'
import CtaAnchorTabs from '~/components/CtaAnchorTabs'
import CtaHeadingBlurbButton from '~/components/CtaHeadingBlurbButton'
import HeadingBlurbSeparator from '~/components/HeadingBlurbSeparator'
import HtmlContent from '~/components/HtmlContent'
import PageUnderConstruction from '~/components/PageUnderConstruction'
import SuperHero from '~/components/SuperHero'
import SubHero from '~/components/SubHero'
import FeaturedCategories from '~/components/featured/FeaturedCategories.vue'
import FeaturedIndustries from '~/components/featured/FeaturedIndustries'
import FeaturedPosts from '~/components/featured/FeaturedPosts'
import FeaturedProfiles from '~/components/featured/FeaturedProfiles'
import FeaturedTestimonials from '~/components/featured/FeaturedTestimonials'
import MapLocations from '~/components/MapLocations.vue'
import PostsLayout from '~/components/PostsLayout.vue'
import EmbedEbook from '~/components/embeds/EmbedEbook.vue'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import Shop from '~/components/Shop.vue'
import ShopRoom from '~/components/shop/ShopRoom.vue'

export default {
    name: 'ContentSection',
    components: {
        ContactPoints,
        ContentColumnImageColumn,
        ContentColumns,
        ContentMultiTabs,
        CtaAnchorTabs,
        CtaHeadingBlurbButton,
        HeadingBlurbSeparator,
        HtmlContent,
        PageUnderConstruction,
        SuperHero,
        SubHero,
        FeaturedCategories,
        FeaturedIndustries,
        FeaturedPosts,
        FeaturedProfiles,
        FeaturedTestimonials,
        MapLocations,
        PostsLayout,
        EmbedEbook,
        EmbedCloudinary2,
        EmbedSanityImage,
        Shop,
        ShopRoom,
    },
    props: {
        section: {
            type: Object,
            default: null,
        },
        thumbnail: {
            type: Object,
            default: null,
        },
        page: {
            type: Object,
            default: null,
        },
    },
    computed: {},
}
</script>
